import React from "react";
import _ from "lodash";
import styled from "styled-components";
import numeral from "numeral";
import { H5, H6 } from "../Typography";
import { getRoomDataForRender } from "../../../src/utils/stat-utils";

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-auto-flow: column;

  div:nth-child(-n + 3) {
    border-right: 1px solid #ebebeb;
  }
  div:nth-child(3n + 1) {
    background-color: #ffffff;
    * {
      color: #666666;
    }
  }

  div:nth-child(3n + 2) {
    background-color: #ed8747;
    * {
      color: #702b00;
    }
  }
  div:nth-child(3n + 3) {
    background-color: #d4bd79;
    * {
      color: #4d3b08;
    }
  }
`;

const Info = styled.div`
  height: 100%;
  max-height: 36px;
  box-sizing: border-box;
  background-color: pink;
  padding: 8px 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TextPrice = styled(H5)`
  font-size: 0.75rem !important;
  text-transform: uppercase;
`;

const TextTitle = styled(H6)`
  font-size: 0.75rem !important;
`;

export default class extends React.PureComponent {
  render() {
    const {
      totalUnits = 0,
      projectStatus = "",
      unitsLeft = 0,
      percentSold = 0,
      absorptionRateLastQ = 0,
      absorptionRateAll = 0,
      rooms,
    } = this.props;
    const avgRoomData = getRoomDataForRender(rooms, [
      { key: "totalUnits", mode: "sum" },
      { key: "unitsLeft", mode: "sum" },
      { key: "percentSold", mode: "avg" },
    ]);
    return (
      <Container>
        <Info>
          <TextTitle>Total Units</TextTitle>
          <TextPrice>
            {_.isNaN(_.get(avgRoomData, "totalUnits")) ||
            _.isUndefined(_.get(avgRoomData, "totalUnits")) ||
            _.get(avgRoomData, "totalUnits") === 0
              ? "N/A"
              : `${numeral(_.get(avgRoomData, "totalUnits")).format("0,0")}`}
          </TextPrice>
        </Info>
        <Info>
          <TextTitle>Project Status</TextTitle>
          <TextPrice>
            {_.isEmpty(projectStatus) ||
            _.isUndefined(projectStatus) ||
            projectStatus === 0
              ? "N/A"
              : `${projectStatus}`}
          </TextPrice>
        </Info>
        <Info>
          <TextTitle>Left Units</TextTitle>
          <TextPrice>
            {_.isNaN(_.get(avgRoomData, "unitsLeft")) ||
            _.isUndefined(_.get(avgRoomData, "unitsLeft")) ||
            _.get(avgRoomData, "unitsLeft") === 0
              ? "N/A"
              : `${numeral(_.get(avgRoomData, "unitsLeft")).format("0,0")}`}
          </TextPrice>
        </Info>
        <Info>
          <TextTitle>% Sold</TextTitle>
          <TextPrice>
            {_.isNaN(_.get(avgRoomData, "percentSold")) ||
            _.isUndefined(_.get(avgRoomData, "percentSold")) ||
            _.get(avgRoomData, "percentSold") === 0
              ? "N/A"
              : `${numeral(_.get(avgRoomData, "percentSold")).format("0.00")}%`}
          </TextPrice>
        </Info>
        <Info>
          <TextTitle>Absorption Last Q</TextTitle>
          <TextPrice>
            {_.isNaN(absorptionRateLastQ) ||
            _.isUndefined(absorptionRateLastQ) ||
            absorptionRateLastQ === 0 ||
            absorptionRateLastQ === '0.00%'
              ? "N/A"
              : absorptionRateLastQ}
          </TextPrice>
        </Info>
        <Info>
          <TextTitle>Overall Absorption</TextTitle>
          <TextPrice>
            {_.isNaN(absorptionRateAll) ||
            _.isUndefined(absorptionRateAll) ||
            absorptionRateAll === 0 ||
            absorptionRateAll === '0.00%'
              ? "N/A"
              : absorptionRateAll}
          </TextPrice>
        </Info>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatDetail/status.js